import { Outlet } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css'
import {Navbar, Container, Nav}  from 'react-bootstrap'


const Layout = () => {
  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand href="#home">React.js: Mangas and Dogs</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/">Characters</Nav.Link>
              <Nav.Link href="/dogs">Dogs</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Outlet />
    </>
  )
}

export default Layout